import { DateTime } from "luxon";

export const formatLocalizedDate = (
  date: Date,
  locale: string,
  format: string = "dd MMM yyyy",
): string => {
  const dt = DateTime.fromJSDate(date).setLocale(locale);
  const formatted = dt.toFormat(format);

  // Capitalize the month
  return formatted.replace(
    /(\d{2}) (\w{3}) (\d{4})/,
    (_, day, month, year) =>
      `${day} ${month.charAt(0).toUpperCase()}${month.slice(1)} ${year}`,
  );
};

export const formatDate = (inputDate: string | number): string => {
  if (typeof inputDate == "number") {
    return DateTime.fromMillis(inputDate).toFormat("MMM dd, yyyy");
  }
  return DateTime.fromISO(inputDate).toFormat("MMM dd, yyyy ");
};
export const formatDateTooltip = (inputDate: string | number): string => {
  if (typeof inputDate == "number") {
    return DateTime.fromMillis(inputDate).toFormat("MMM dd, yyyy");
  }
  return DateTime.fromISO(inputDate).toFormat("dd MMM  yyyy ");
};

export const formatDateTime = (inputDate: string | number): string => {
  if (typeof inputDate == "number") {
    return DateTime.fromMillis(inputDate).toFormat("MMM dd, yyyy 'at' hh:mm a");
  }
  return DateTime.fromISO(inputDate).toFormat("MMM dd, yyyy 'at' hh:mm a");
};

export const formatDateChatUserMessage = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return "now";
  }

  if (
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear() &&
    diffInSeconds < 12 * 3600
  ) {
    return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
  }

  return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")} ${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}`;
};

export const utilsFormatDatePortfolioEvolutionChart = (date: string) => {
  const d = new Date(date);
  return `${d.toLocaleString("default", { month: "short" })} ${d.getFullYear().toString()}`;
};
